import Vue from 'vue'
import Router from 'vue-router'
//引入页面
import Index from '../pages/index.vue'
import AboutUs from '../pages/aboutUs.vue'
import Product from '../pages/product.vue'
import Service from '../pages/service.vue'
import Shop from '../pages/shop.vue'
import Policy from '../pages/policy.vue'
import Question from '../pages/question.vue'
import Download from '../pages/download.vue'
import Relation from '../pages/relation.vue'
import hR from '../pages/homeRecommand.vue'
import Productstation from '../pages/Productstation.vue'
import jointproduct from '../pages/JointProduct.vue'
import sales from '../pages/sales.vue'
import meetingShake from '../pages/meeting/meetingShake.vue'
import shakePage from '../pages/meeting/shakePage.vue'
import card from '../pages/meeting/card.vue'
import SignIn from '../pages/meeting/SignIn.vue'
import News from '../pages/News.vue'
import ProductPage from '../pages/ProductPage.vue'
Vue.use(Router)

const routes = [{
		path: '*',
		redirect: '/index'
	},
	{
		path: '/index',
		component: Index,
		meta: {
			title: '乐范健康科技'
		}
	}, {
		path: '/about-us',
		component: AboutUs,
		meta: {
			title: '关于乐范'
		}
	}, {
		path: '/product',
		component: Product,
		meta: {
			title: '产品介绍'
		}
	}, {
		path: '/service',
		component: Service,
		meta: {
			title: '服务支持'
		}
	}, {
		path: '/shop',
		component: Shop,
		meta: {
			title: '官方网店'
		}
	}, {
		path: '/policy',
		component: Policy,
		meta: {
			title: '售后政策'
		}
	}, {
		path: '/question',
		component: Question,
		meta: {
			title: '产品介绍视频'
		}
	}, {
		path: '/download',
		component: Download,
		meta: {
			title: 'App下载'
		}
	}, {
		path: '/relation',
		component: Relation,
		meta: {
			title: '联系我们'
		}
	}, {
		path: '/hR',
		component: hR,
		meta: {
			title: '部位推荐'
		}
	},
	{
		path: '/Productstation',
		component: Productstation,
		meta: {
			title: '产品站'
		}
	},
	{
		path: '/news',
		component: News,
		meta: {
			title: '新闻'
		}
	},
	// {
	// 	path: '/productPage',
	// 	component: ProductPage,
	// 	meta: {
	// 		title: '产品站'
	// 	}
	// },
	{
		path: '/jointproduct',
		component: jointproduct,
		meta: {
			title: '跨界联名产品'
		}
	},
	{
		path: '/sales',
		component: sales,
		meta: {
			title: '销量领先产品'
		}
	},
	
	{
		path: '/meetingcard',
		component: card,
		meta: {
			title: '年会抽奖'
		}
	},
	{
		path: '/meetingShake',
		component: meetingShake,
		meta: {
			title: '年会摇一摇'
		}
	},
	{
		path: '/meetingShakePage',
		component: shakePage,
		meta: {
			title: '摇一摇中奖界面'
		}
	},
	{
		path: '/meetingSignIn',
		component: SignIn,
		meta: {
			title: '签到'
		}
	}
]

export default new Router({
	routes,
	mode: 'history',
})
